// extracted by mini-css-extract-plugin
module.exports = {"stepsContent":"stepsContent[Frida]1MtP4yrs","stepsAction":"stepsAction[Frida]1CVsocG3"};